import React, { memo, useCallback, useContext } from "react";
// contexts
import { SuperContext } from "@super-ui/contexts";
// components
import { AriaHidden, RightArrow, useEffectOnce } from "@swiggy-private/core-ui";
// constants
import { ONE_WIDGET_TEST_IDS } from "@swiggy-private/cart-test-ids";
import { UX4_PRIMARY_ORANGE } from "@super-ui/constants/Color";
// types
import { FooterComms } from "@super-ui/interfaces/SwiggyOne";
// styles
import styles from "../styles/SuperViewDetailsFooter.scss";
import { isEmpty } from "@swiggy-private/js-utils";

interface SuperViewDetailsFooterProps {
    footerComms: FooterComms;
}

const SuperViewDetailsFooter = ({ footerComms }: SuperViewDetailsFooterProps) => {
    const {
        showDetailsFromSuperFooter,
        analyticsEvents: { onImpressionSuperViewDetailsFooterWidget, onClickSuperViewDetailsFooterWidget },
    } = useContext(SuperContext);

    const mainText = footerComms;
    const ctaText = footerComms?.cta?.text;

    const onCTAClick = useCallback(() => {
        if (typeof showDetailsFromSuperFooter === "function") {
            onClickSuperViewDetailsFooterWidget(ctaText);
            showDetailsFromSuperFooter(footerComms?.cta?.link);
        }
    }, [ctaText, footerComms, onClickSuperViewDetailsFooterWidget, showDetailsFromSuperFooter]);

    useEffectOnce(() => {
        onImpressionSuperViewDetailsFooterWidget(ctaText);
    });

    return (
        <div className={styles.superViewDetailsFooterContainer} data-testid={ONE_WIDGET_TEST_IDS.VIEW_DETAILS_FOOTER}>
            <span
                className={styles.superViewDetailsFooterHeading}
                data-testid={ONE_WIDGET_TEST_IDS.VIEW_DETAILS_FOOTER_HEADING}
            >
                {mainText}
            </span>
            {!isEmpty(ctaText) && (
                <button
                    data-testid={ONE_WIDGET_TEST_IDS.VIEW_DETAILS_FOOTER_CTA}
                    onClick={onCTAClick}
                    className={styles.superViewDetailsFooterCTA}
                    aria-label={ctaText}
                >
                    <AriaHidden as="div">
                        {ctaText}
                        <RightArrow color={UX4_PRIMARY_ORANGE} className={styles.superViewDetailsFooterCTAArrow} />
                    </AriaHidden>
                </button>
            )}
        </div>
    );
};

export default memo(SuperViewDetailsFooter);
